import List from "@/modules/settings/workdays/views/List"
import { Route, Routes } from "react-router-dom"
export const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<List />} />
    </Routes>
  )
}
